// Full-document render of the Oscar address-delete confirm view:
// PageSkeleton wrapping the tempurpedic breadcrumb shell ("Your
// Account / Your Addresses / Your Address Book") and the delete-confirmation
// form. The address-list crumb reuses cancel_url (both point at
// customer:address-list). The confirm/summary/label copy is server-resolved;
// the breadcrumb + aria-label copy uses ttag `t` for tempurca (fr_CA).
import React from "react";
import { t } from "ttag";

import { templates } from "@reactivated";

import { CSRFToken } from "@reactivated/forms";

import { AccountBreadcrumbShell } from "../components/AccountBreadcrumbShell";
import { PageSkeleton } from "../components/PageSkeleton";

export const Template = (
    props: templates.AddressDeleteDocumentTemplate,
): React.JSX.Element => (
    <PageSkeleton pageChrome={props.page_chrome}>
        <AccountBreadcrumbShell
            crumbs={[
                { label: t`Your Account`, href: props.profile_url },
                { label: t`Your Addresses`, href: props.cancel_url },
                { label: t`Your Address Book` },
            ]}
            heading={t`Your Address Book`}
        >
            <div className="account-form">
                <form method="post" action={props.action_url}>
                    <CSRFToken />
                    <p>{props.confirm_message}</p>
                    <p>
                        <strong>{props.address_summary}</strong>
                    </p>
                    <div className="form-group form-actions">
                        <button
                            type="submit"
                            aria-label={t`Submit`}
                            className="button"
                            data-loading-text={props.deleting_label}
                        >
                            {props.delete_label}
                        </button>{" "}
                        {props.or_label}{" "}
                        <a
                            className="address-delete-link"
                            href={props.cancel_url}
                        >
                            {props.cancel_label}
                        </a>
                    </div>
                </form>
            </div>
        </AccountBreadcrumbShell>
    </PageSkeleton>
);
